import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { jsonToParam,getURL } from "src/utils/config"
import { handleResponse } from "src/utils/responseHandler"
import axios from 'src/axios'


const useAgentLatencyReport = () => {

    const [ reportData, setReportData ] = useState({ data: [], username: '',  avgTime: '',  eventsCount: 0})

    const { date, agentId, hour } = useParams()

    useEffect(() => {
        getAgentWiseReport({
            date: date,
            agentId: agentId,
            hour: hour
        })
    }, [date, agentId, hour])    

    const manageReportData = (data) => {
        let username = ''
        let auditsCount = 0
        let audits = []
        let avgAuditTime = ''

        if (data.hasOwnProperty('audits'))
            audits = data.audits
        if (data.hasOwnProperty('agent_details') && data.agent_details.length > 0) {
            username = data.agent_details[0].agentname
            avgAuditTime = data.agent_details[0].averagereviewtimeperaudit
        }
        if (data.hasOwnProperty('EventsCount'))
            auditsCount = data.EventsCount

        return [username, auditsCount, avgAuditTime, audits]
    }


    const getAgentWiseReport = (formdata) => {
        axios({
            method: 'get',
            url: getURL(`agent-reports/get-hourly-latency-info?${jsonToParam(formdata)}`),
            validateStatus: (status) => handleResponse(status)
        }).then((response) => {
            if (response.status === 200 || response.status === 201) {
                // console.log("Latency Data ",response.data);
                const [ username, auditsCount, avgAuditTime, audits ] = manageReportData(response.data)
                setReportData({...reportData, data: audits, username: username, avgTime: avgAuditTime, eventsCount: auditsCount})
            }
        })
    }
    

    return [ reportData ]
}

export default useAgentLatencyReport